import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { PrimeReactProvider } from 'primereact/api';

// Context Providers
import { AuthProvider } from './contexts/AuthContext';

// Route Components
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';
import PublicRoute from './components/PublicRoute';

// Layout Components
import Layout from './components/Layout';

// Page Components
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import PersonalSettings from './pages/account/PersonalSettings';
import Orders from './pages/account/Orders';
import Credits from './pages/account/Credits';
import ChangePassword from './pages/account/ChangePassword';
import Memberships from './pages/account/Memberships';
import HorseRegistration from './pages/HorseRegistration';
import Rides from './pages/Rides';
import RideResults from './pages/RideResults';
import RideReports from './pages/RideReports';
import ManageHorseRegistrations from './pages/ManageHorseRegistrations';
import Horses from './pages/Horses';
import Events from './pages/Events';
import EventDetail from './pages/EventDetail';
import EventDetailBooking from './pages/EventDetailBooking';
import Shop from './pages/Shop';
import ShopCategory from './pages/ShopCategory';
import ProductDetail from './pages/ProductDetail';
import Documents from './pages/Documents';

import './App.css';

function App() {
  return (
    <PrimeReactProvider>
      <AuthProvider>
        <Router>
          <div className="App">
            <Routes>
              {/* Public Routes */}
              <Route path="/login" element={
                <PublicRoute>
                  <Login />
                </PublicRoute>
              } />
              <Route path="/register" element={
                <PublicRoute>
                  <Register />
                </PublicRoute>
              } />
              
              {/* Protected Routes with Layout */}
              <Route path="/" element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }>
                <Route index element={<Navigate to="/dashboard" replace />} />
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="horses" element={<Horses />} />
                <Route path="ridersults" element={<RideResults />} />
              
                {/* Account Routes */}
                <Route path="account/personal" element={<PersonalSettings />} />
                <Route path="account/orders" element={<Orders />} />
                <Route path="account/credits" element={<Credits />} />
                <Route path="account/password" element={<ChangePassword />} />
                <Route path="account/memberships" element={<Memberships />} />
                
                {/* Other Routes */}
                <Route path="horse-registration" element={<HorseRegistration />} />
                <Route path="rides" element={<Rides />} />
                <Route path="rideresults" element={<AdminRoute><RideResults /></AdminRoute>} />
                <Route path="ridereports" element={<AdminRoute><RideReports /></AdminRoute>} />
                <Route path="manage-horses" element={<AdminRoute><ManageHorseRegistrations /></AdminRoute>} />
                <Route path="events" element={<Events />} />
                <Route path="events/:eventId/waitlist" element={<EventDetail />} />
                <Route path="events/:eventId/book" element={<EventDetailBooking />} />
                <Route path="events/:eventId" element={<EventDetail />} />
                <Route path="shop" element={<Shop />} />
                <Route path="shop/category/:categoryId" element={<ShopCategory />} />
                <Route path="shop/product/:productId" element={<ProductDetail />} />
                <Route path="documents" element={<Documents />} />
              </Route>
              
              {/* Catch all route */}
              <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Routes>
          </div>
        </Router>
      </AuthProvider>
    </PrimeReactProvider>
  );
}

export default App;
